// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2C6qd","productName":"Table_productName__-dJjH"};